import { createFileRoute, Navigate } from '@tanstack/react-router';
import { canEditGlobalCatalog } from '../../../features/auth/admin-capabilities';
import { useAuth } from '../../../features/auth/auth-context';
import { defaultAdminHome } from '../../../features/auth/default-admin-home';
import { EventCategoryForm } from '../../../features/event-categories/components/event-category-form';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/event-categories/new')({
  staticData: { breadcrumb: 'Новая' },
  component: NewEventCategoryPage,
});

function NewEventCategoryPage() {
  const { adminRoles } = useAuth();
  if (!canEditGlobalCatalog(adminRoles)) {
    return <Navigate to={defaultAdminHome(adminRoles)} />;
  }
  return (
    <div>
      <PageHeader title="Новая категория" />
      <EventCategoryForm mode="create" />
    </div>
  );
}
